<template>
	<div id="allmap" :style="{width: '100%', height: mapHeight + 'px'}"></div>
</template>
<script>
	export default {
		name: 'BMapComponent',
		data:function(){
			return{
				mapStyle:{
					width:'100%',
					height:this.mapHeight +'px',
					address_detail: '北京市朝阳区',
				}
			}
		},
		mounted () {
			this.ready()
		},
		props:{
	      	// 地图在该视图上的高度
	      	mapHeight:{
	      		type: Number,
	      		default: 450
	      	},
	      	// 经度
	      	longitude:{
	      		type: Number,
	      		default: 116.408767
	      	},
	      	// 纬度
	      	latitude:{
	      		type: Number,
	      		default: 39.984651
	      	}
	    },
	    methods: {
	      	ready: function () {
	      		var map = new BMap.Map("allmap");
	      		var point = new BMap.Point(this.longitude,this.latitude);
				map.centerAndZoom(point,16);
				map.enableScrollWheelZoom(true);//滚轮放大缩小
	      		var marker = new BMap.Marker(point);

				var content ="<div>"+
						"<img src='http://ttest2.oss-cn-hangzhou.aliyuncs.com/haifeng/address.jpg'><span style='font-size:14px;color:#000000;background-color:#FFFFFF;'>  北京市朝阳区北投投资大厦B座11层</span>" +
						"<br/>" +
						"<img src='http://ttest2.oss-cn-hangzhou.aliyuncs.com/haifeng/phone.png'><span style='font-size:14px;color:#000000;background-color:#FFFFFF;'>  010-66001835/39</span>" +
						"<br/>" +
						"<img src='http://ttest2.oss-cn-hangzhou.aliyuncs.com/haifeng/online.png'><span style='font-size:14px;color:#000000;background-color:#FFFFFF;'>  www.vistastory.com</span>"+
						"</div>"
		        var opts = {
		        	width :250,
		        	height:65,
					title: "",
		        }
				var infoWindow =new BMap.InfoWindow(content, opts);// 创建信息窗口对象

				// var html = [];
				// html.push("<div  style='width:250px;height:70px'>");
				// html.push("<img src='../../assets/png/address.jpg'><span style='font-size:14px;color:#000000;background-color:#FFFFFF'>  北京市朝阳区惠新里3号院A座3层</span>");
				// html.push("<img src='../../assets/png/phone.png'>  010-66001835/39");    
				// html.push("<img src='../../assets/png/online.png'>  www.vistastory.com");
				// html.push("</div>");
				// var infoWindow = new BMap.InfoWindow(html.join(""), {enableMessage: false,enableCloseOnClick:false});

				marker.addEventListener("click",function(){
					map.openInfoWindow(infoWindow,point);
					// marker.openInfoWindow(infoWindow); //开启信息窗口
				});
				map.centerAndZoom(point,16);
				map.enableScrollWheelZoom(true);//滚轮放大缩小
				map.openInfoWindow(infoWindow,point);//开启信息窗口
				map.addOverlay(marker);

		        var b = new BMap.Bounds(new BMap.Point(116.416428,39.981918),new BMap.Point(116.438257,39.989699)); // 范围 左下角，右上角的点位置
			    try {    // js中尽然还有try catch方法，可以避免bug引起的错误
			        BMapLib.AreaRestriction.setBounds(map, b); // 已map为中心，已b为范围的地图
			    } catch (e) {
			        // 捕获错误异常
			        alert(e);
			    }
			}
		}
	}
</script>

<!--Add"scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/web/BMapComponent.vue